export const SAVE_POSTS = 'SAVE_POSTS';
export const SAVE_CATEGORY = 'SAVE_CATEGORY';
export const SAVE_TAGS = 'SAVE_TAGS';



// WEBPACK FOOTER //
// ./src/taskflex/blog/store/_types.js